/* eslint-disable no-bitwise */


function addDiscretizerCapabilities (object, {
    xMin, xMax, yMin, yMax,
    cellSize,
    xCellsCount = object.width,
    yCellsCount = object.height
}) {

    let xRatio
    let yRatio

    if (cellSize) {
        xRatio = 1 / cellSize
        yRatio = xRatio

        xCellsCount = Math.ceil((xMax - xMin) * xRatio)
        yCellsCount = Math.ceil((yMax - yMin) * yRatio)

    } else {
        if (!xCellsCount) {
            throw new Error("Discretizer needs a cellSize or a xCellsCount param or a width on the object")
        }

        if (!yCellsCount) {
            throw new Error("Discretizer needs a cellSize or a yCellsCount param or a height on the object")
        }

        xRatio = xCellsCount / (xMax - xMin)
        yRatio = yCellsCount / (yMax - yMin)
    }


    const lastXCell = xCellsCount - 1
    const lastYCell = yCellsCount - 1

    object.discretize = function ({x, y}) {
        if (!(x >= xMin && x <= xMax && y >= yMin && y <= yMax)) {
            return null
        }
        return {
            x: Math.min(lastXCell, ((x - xMin) * xRatio) | 0),
            y: Math.min(lastYCell, ((yMax - y) * yRatio) | 0)
        }
    }


    object.gridIndexToGridCoords = function (index) {
        let yGrid = (index / xCellsCount) | 0
        return {
            x: index - yGrid * xCellsCount,
            y: yGrid
        }
    }


    const invXRatio = 1 / xRatio
    const invYRatio = 1 / yRatio

    const xMinForPixelCenter = xMin + 0.5 * invXRatio
    const yMaxForPixelCenter = yMax - 0.5 * invYRatio


    object.gridIndexToCoords = function (index) {
        let yGrid = (index / xCellsCount) | 0
        return {
            x: xMinForPixelCenter + (index - yGrid * xCellsCount) * invXRatio,
            y: yMaxForPixelCenter - (yGrid * invYRatio)
        }
    }


    object.gridCoordsToCoords = function ({x, y}) {
        return {
            x: xMinForPixelCenter + (x * invXRatio),
            y: yMaxForPixelCenter - (y * invYRatio)
        }
    }

    return {
        xCellsCount,
        yCellsCount
    }

}


export default addDiscretizerCapabilities
